module.exports = __webpack_public_path__ + "static/media/29.aed8531f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/29.png
// module id = 1070
// module chunks = 0